export default __webpack_public_path__ + "static/media/CU50ENSVN.cbbe8e3c.jpg";